module.exports = __webpack_public_path__ + "media/images/fuda04-5d55e3cf3ca61fc539d04a3680a55ed6.jpg";